import ExportButtons from "./export-buttons";

interface Props {
  accountList?: any[];
  isListClients?: boolean;
  searchText?: string;
  onSearchChange?: (value: string) => void;
  onLoad?: () => void;
  onReset?: () => void;
  pageSize?: number;
  onPageSizeChange?: (size: number) => void;
}

const PreUserTable = ({
  accountList = [],
  isListClients = false,
  searchText = "",
  onSearchChange,
  onLoad,
  onReset,
  pageSize = 25,
  onPageSizeChange,
}: Props) => {
  return (
    <>
      <div className="row row5">
        <div className="col-md-6 mb-2 search-form">
          {!isListClients && <ExportButtons accountList={accountList} />}
        </div>
        <div className="col-md-6 text-right mb-2" />
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-6">
          <div id="tickets-table_length" className="dataTables_length">
            <label className="d-inline-flex align-items-center" htmlFor="entriesPerPage">
              Show&nbsp;
              <select
                className="custom-select custom-select-sm"
                id="entriesPerPage"
                value={pageSize}
                onChange={(e) => onPageSizeChange?.(Number(e.target.value))}
              >
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="250">250</option>
                <option value="500">500</option>
                <option value="750">750</option>
                <option value="1000">1000</option>
              </select>
              &nbsp;entries
            </label>
          </div>
        </div>
        <div className="col-sm-12 col-md-6">
          <div
            id="tickets-table_filter"
            className="dataTables_filter text-md-right"
          >
            <label className="d-inline-flex align-items-center" htmlFor="searchuser">
              Search:
              <input
                name="searchuser"
                id="searchuser"
                type="search"
                placeholder="Search..."
                className="form-control form-control-sm ml-2"
                value={searchText}
                onChange={(e) => onSearchChange?.(e.target.value)}
              />
              <button
                type="button"
                id="loaddata"
                className="btn btn-primary ml-2"
                onClick={onLoad}
              >
                Load
              </button>
              <button
                type="button"
                id="resetdata"
                className="btn btn-secondary ml-2"
                onClick={onReset}
              >
                Reset
              </button>
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

export default PreUserTable;
